<ng-container *ngIf="isImpersonated()">
  <div class="impersonator">
    <div class="container">
      <button class="btn btn-danger pul-right" (click)="logout()">Drop access</button>
      You are impersonating {{ Auth.username }} ({{Auth.email}}), don't forget to logout after your job is done here!
    </div>
  </div>

</ng-container>
<div class="module-loader" [hidden]="!loading"></div>
<router-outlet></router-outlet>
<div class="modal-outlet" [hidden]="!outlet.isActivated">
  <div class="modal-outlet-content">
    <router-outlet name="modal" #outlet="outlet" (activate)="modalRouterEvent($event)" (deactivate)="modalRouterEvent($event)"></router-outlet>
  </div>
</div>
<app-alert></app-alert>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/app.component.html